console.log('Custom signup scripts.')

// Initialize the intlTelInput plugin
const emailInput = document.querySelector('#email-signup')
const phoneInput = document.querySelector("#phone-signup")
const iti = intlTelInput(phoneInput, {
  utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.21/js/utils.min.js',
  onlyCountries: ['us', 'ca', 'gb', 'au', 'nz'],
})
const fullNameInput = document.querySelector('#fullname-input')

const phoneSignup = document.querySelector('#phone-signup-wrapper')

const selectEmail = document.querySelector('#select-email')
const selectSms = document.querySelector('#select-sms')

const signupSubmit = document.querySelector('#signup-submit')

selectEmail.addEventListener('click', (event) => {
  event.preventDefault()
  validateEmail()
  selectEmail.classList.add('active')
  selectSms.classList.remove('active')
  emailInput.classList.remove('hidden')
  phoneSignup.classList.add('hidden')

  emailDisclaimerContainer.classList.remove('hidden')
  phoneDisclaimerContainer.classList.add('hidden')
})
selectSms.addEventListener('click', (event) => {
  event.preventDefault()
  validatePhoneNumber()
  selectEmail.classList.remove('active')
  selectSms.classList.add('active')
  emailInput.classList.add('hidden')
  phoneSignup.classList.remove('hidden')

  emailDisclaimerContainer.classList.add('hidden')
  phoneDisclaimerContainer.classList.remove('hidden')
})

emailInput.addEventListener('input', validateEmail);
// emailInput.addEventListener('keyup', ({ key }) => {
//   if (key === 'Enter') {
//     onSubmitClick();
//   }
// });
phoneInput.addEventListener('input', validatePhoneNumber);

signupSubmit.addEventListener('click', async (event) => {
  signupSubmit.classList.add('loading')

  let bodyObj = {
    fullname: fullNameInput.value,
    email: emailInput.value,
    formId: 'shopify-signup'
  }
  if (validatePhoneNumber()) {
    bodyObj.listId = 'TwBAer'
    bodyObj.phoneNumber = iti.getNumber()
  }
  if (validateEmail()) {
    bodyObj.listId = 'SKawYP'
    bodyObj.email = emailInput.value
  }

  const rootUrl = 'https://www.thegamma.com'
  let endpointUrl = rootUrl + '/api/signup'
  console.log('Body: ', bodyObj)

  let response = await fetch(endpointUrl, {
    mode: 'cors',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(bodyObj),
  })

  console.log('response', response)
  console.log('status', response.status)

  //check status
  if (response.status == 200) {
    if (bodyObj.email) {
      showResponse(emailInput, 'check your inbox to complete.');
      validateEmail()
    }
    if (bodyObj.phoneNumber) {
      showResponse(phoneInput, 'check your phone to complete.')
      validatePhoneNumber()
    }
  } else {
    if (bodyObj.email) {
      showResponse(emailInput, 'there was an issue, please try again.');
    }
    if (bodyObj.phoneNumber) {
      showResponse(phoneInput, 'there was an issue, please try again.')
    }
  }

  signupSubmit.classList.remove('loading')
})

const emailDisclaimerContainer = document.querySelector('#email-disclaimer-container')
const phoneDisclaimerContainer = document.querySelector('#phone-disclaimer-container')
const emailConsent = document.querySelector('#email-consent')
const smsConsent = document.querySelector('#sms-consent')
emailConsent.addEventListener('change', validateEmail)
smsConsent.addEventListener('change', validatePhoneNumber)

function validatePhoneNumber () {
  let validPhoneNumber = false
  if (iti.isValidNumber()) {
    console.log('Valid number')
    phoneDisclaimerContainer.classList.add('open');
    validPhoneNumber = true
  } else {
    console.log('Invalid number')
    validPhoneNumber = false
  }

  if (smsConsent.checked && validPhoneNumber) {
    signupSubmit.removeAttribute('disabled')
    return true
  } else {
    signupSubmit.setAttribute('disabled', true)
    return false
  }
}

function validateEmail() {
  let validEmail = false
  if (/(.+)@(.+){2,}\.(.+){2,}/.test(emailInput.value)) {
    // Modify the UI to show disclaimer
    emailDisclaimerContainer.classList.add('open');
    // uiContainer.classList.add('open')
    validEmail = true
  } else {
    // invalid email
    validEmail = false
  }

  if (emailConsent.checked && validEmail) {
    // valid email
    signupSubmit.removeAttribute('disabled')
    return true
  } else {
    signupSubmit.setAttribute('disabled', true)
    return false
  }
}

function showResponse(target, str) {
  target.value = '';
  target.placeholder = str;
}
